<template>
    <div>
        <div class="table-layout">
            <el-table ref="multipleTable" :data="merchantList" :row-key="getRowKeys" border style="width: 100%" highlight-current-row @current-change="handleCurrentChange" @selection-change="handleSelectionChange">
                <el-table-column :key="Math.random()" width="55" v-if="!multiSelect">
                    <template slot-scope="rows">
                        <el-radio v-model="selectMerchant.id" :label="rows.row.id">&nbsp;</el-radio>
                    </template>
                </el-table-column>
                <el-table-column :key="Math.random()" width="55" :selectable="selectable" align="center" type="selection" v-if="multiSelect"></el-table-column>
                <el-table-column :key="Math.random()" prop="name" label="商户名称" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column :key="Math.random()" width="150" prop="registCapital" label="注册资金(元)" align="right">
                    <template slot-scope="rows">
                        <div v-if="rows.row.registCapital != null">
                            <span>{{((rows.row.registCapital).toFixed(2)).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')}}</span>
                        </div>
                        <div v-else>
                            <span>0.00</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :key="Math.random()" width="100" prop="foundDate" label="注册日期" align="center"></el-table-column>
                <el-table-column :key="Math.random()" width="200" prop="regionName" label="注册地址" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column :key="Math.random()" width="150" prop="industryTypeName" label="经营模式" align="left" show-overflow-tooltip></el-table-column>

                <el-table-column :key="Math.random()" width="100" prop="industryTypeName" label="是否加黑" align="center">
                    <template slot-scope="rows">
                        <span v-if="rows.row.blacked" class="font-red">是</span>
                        <span v-else>否</span>
                    </template>
                </el-table-column>
                <el-table-column :key="Math.random()" width="150" prop="blackenCause" label="加黑原因" align="left" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>
        <div class="block pagination-layout">
            <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils, EventBus } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'

    import servicerApi from '../../api/servicer'

    export default {
        name: 'swb-servicer-list-select',
        desc: '通用服务商选择',
        props: {
            name: {
                type: String,
                default: null
            },
            devcGroupId: {  // 默认服务商-根据过滤
                type: Object,
                default: null
            },
            retailerComId: {  // 默认服务商-根据过滤
                type: Number,
                default: null
            },
            devcDefIds: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            servcType: {
                type: Number,
                default: null
            },
            //是否多选
            multiSelect: {
                type: Boolean,
                default: true
            },
            multiSelectDisabled: {
                type: Boolean,
                default: false
            },
            //单选初始选择项
            checkedItem: {
                type: Object,
                default: null
            },
            initCheckedIds: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            checkedIds: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            //多选初始选择项
            checkedList: {// 多选的时候传入
                type: Array,
                default: function () {
                    return [];
                }
            },
            seachQueryModel: {
                type: Object,
                default: function () {
                    return {
                        filterItems: {},
                        sortItemList: [],
                        sortItems: {}
                    };
                }
            },
            operation: {
                type: String,
                default: null
            }
        },
        data: function () {
            return {
                //分页信息
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                queryModel: {
                    filterItems: {
                        unexpired: true
                    },
                    sortItemList: [],
                    sortItems: {}
                },
                //
                merchantList: [],
                selectMerchant: {},
                checkedDelay: 100,
                checkedIniting: false,
                checkedTblRefId: 'multipleTable',
                //
                getRowKeys(row) {
                    return row.id;
                },
            }
        },
        watch: {
            checkedIds(newVal, oldVal){
                let self = this;
                let operation = this.operation;
                if(newVal != oldVal && operation != null && operation != this.name) {
                    //
                    self.checkedIniting = true;
                    self.$refs[self.checkedTblRefId].clearSelection();
                    newVal = newVal == null ? [] : newVal.clone();
                    oldVal = oldVal == null ? [] : oldVal.clone();
                    let rows = this.merchantList;
                    rows.forEach(function (row) {
                        if(newVal.indexOf(row.id) >= 0) {
                            self.$refs[self.checkedTblRefId].toggleRowSelection(row);
                        }
                    });
                    self.checkedIniting = false;
                }
            },
            checkedItem(newVal, oldVal){
                let operation = this.operation;
                if(newVal != oldVal && operation != null && operation != this.name) {
                    //
                    this.selectMerchant = Utils.merge({}, newVal);
                }
            },
            seachQueryModel(newVal, oldVal){
                let operation = this.operation;
                if(newVal != oldVal && operation != null && operation == this.name) {
                    //
                    this.queryModel = Utils.merge({}, newVal);
                    this.pageNumber = 1;
                    this.getMerchantList();
                }
            },
            operation(newVal, oldVal){
                if(newVal != oldVal && newVal != null && newVal == this.name) {
                    //
                    this.queryModel = Utils.merge({}, this.seachQueryModel);
                    this.pageNumber = 1;
                    this.getMerchantList();
                }
            }
        },
        created: function () {
            //
            this.pageSize = this.pageSizes.first();
            this.pageNumber = 1;
            //
            this.selectMerchant = this.checkedItem || {};
            //
            this.getMerchantList();
        },
        beforeDestroy () {
        },
        methods: {
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                //
                this.handlePageChange(newPageNumber);

            },
            handlePageChange: function (val) {
                if(this.checkedIniting) {
                    return;
                } else {
                    this.checkedIniting = true;
                }
                //
                this.pageNumber = val;
                //
                this.getMerchantList();
            },
            selectable: function (row, index) {
                if(this.multiSelectDisabled) {
                    let initCheckedIds = this.initCheckedIds;
                    if(initCheckedIds.indexOf(row.id) >= 0) {
                        return false;
                    } else {
                        return true;
                    }
                } else {
                    return true;
                }
            },
            addCheckId: function (id, val, checkedIds, checkedList) {
                // let checkedIds = Utils.merge([], this.checkedIds);
                // let checkedList = Utils.merge([], this.checkedList);
                if(!checkedIds.contains(id)) {
                    checkedIds.add(id);
                    checkedList.add(val);
                    return id;
                }
                return null;
            },
            delCheckId: function (id, checkedIds, checkedList) {
                let self = this;
                // let checkedIds = Utils.merge([], this.checkedIds);
                // let checkedList = Utils.merge([], this.checkedList);
                if(checkedIds.contains(id)) {
                    for(let i = 0; i < checkedList.length; i++) {
                        let checkedStuff = checkedList[i];
                        if(checkedStuff.id == id) {
                            checkedList.splice(i, 1);
                        }
                    }
                    checkedIds.remove(id);
                    return id;
                }
                return null;
            },
            handleSelectionChange: function (selRows) {
                let self = this;
                if(self.checkedIniting) {
                    return;
                }
                let checkedIds = Utils.merge([], this.checkedIds);
                let checkedList = Utils.merge([], this.checkedList);
                //
                let allIds = self.merchantList.pluck("id");
                let selIds = selRows.pluck("id");
                selIds.forEach(function (id, index) {
                    self.addCheckId(id, selRows[index], checkedIds, checkedList);
                });
                let lesIds = Utils.compareArrays(selIds, allIds)["less"];
                lesIds.forEach(function (id, index) {
                    self.delCheckId(id, checkedIds, checkedList);
                });
                //
                let item = {};
                item.checkedIds = checkedIds;
                item.checkedList = checkedList;
                item.operation = this.name;
                this.$emit("handle-change", item);
            },
            restoreSelRows(dataRows, tblRefId, idProp){
                let self = this;
                self.checkedIniting = true;
                idProp = idProp || "id";
                let allIds = dataRows.pluck(idProp);
                let selIds = Utils.compareArrays(allIds, this.checkedIds)["same"];
                selIds.forEach(function (id) {
                    self.toggleListRowById(dataRows, tblRefId, idProp, id);
                });
                //
                self.checkedIniting = false
            },
            toggleListRowById(dataRows, tblRefId, idProp, idVal){
                let self = this;
                //
                idProp = idProp || "id";
                let refTbl = self.$refs[tblRefId];
                let theRow = dataRows.find(function (row, idx) {
                    return row[idProp] == idVal;
                });
                if(theRow != null) {
                    refTbl.toggleRowSelection(theRow);
                }
            },
            getMerchantList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };

                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.selectType = this.name;
                if(!Utils.isNoB(self.servcType)) {
                    filterItems.servcType = self.servcType;
                }
                if(!Utils.isNoB(self.devcDefIds) && self.devcDefIds.length > 0) {
                    filterItems.devcDefIds = self.devcDefIds;
                }
                if(!Utils.isNoB(self.devcGroupId)) {
                    filterItems.devcGroupId = self.devcGroupId;
                }
                if(!Utils.isNoB(self.retailerComId)) {
                    filterItems.retailerComId = self.retailerComId;
                }
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoad = MsgBox.loading();
                servicerApi.getMerchantDtoList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        self.merchantList = result.data.rows;
                        //
                        self.totalCount = result.data.pagination.totalCount;
                        //
                        setTimeout(function () {
                            self.restoreSelRows(self.merchantList, self.checkedTblRefId, 'id');
                        }, self.checkedDelay);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 单选
            handleCurrentChange: function (val) {
                if(this.multiSelect == null || this.multiSelect == false) {
                    let checkedItem = this.selectMerchant;
                    if(val != null && val.id != checkedItem.id) {
                        this.selectMerchant = Utils.merge({}, val);
                        //
                        let item = {};
                        item.checkedItem = val;
                        item.operation = this.name;
                        this.$emit("handle-change", item);
                    }
                }
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/servicer/ComnForSelect.vue